import { useEffect, useRef, useState } from "react";

export const TERMS = {
  RCBE: "Registo Central do Beneficiário Efetivo: indica os donos reais da empresa",
  IMI: "Imposto Municipal sobre Imóveis: pago todos os anos pelo dono do imóvel",
  IMT: "Imposto Municipal sobre as Transmissões: pago pelo comprador antes da escritura",
  CMI: "Contrato de Mediação Imobiliária: o contrato entre o proprietário e a agência",
  CPCV: "Contrato-Promessa de Compra e Venda: o acordo assinado antes da escritura",
  ARU: "Área de Reabilitação Urbana: zona onde a Câmara pode ter direito de preferência",
  PEP: "Pessoa politicamente exposta: pergunta da lei do branqueamento — o cliente tem ou teve cargo político?",
  "Pessoa politicamente exposta": "Pergunta da lei do branqueamento: o cliente tem ou teve cargo político?",
  passo: "Uma ação que não é um documento, por exemplo confirmar que o crédito está aprovado",
  NIPC: "Número de Identificação de Pessoa Coletiva: o número fiscal da empresa",
  FINE: "Ficha de Informação Normalizada Europeia: resumo das condições do crédito",
};
const RE = new RegExp(`\\b(${Object.keys(TERMS).join("|")})\\b`);

export function Term({ t, tip, label }) {
  const [pos, setPos] = useState(null);
  const ref = useRef(null), mouse = useRef(false);
  const show = () => {
    const r = ref.current.getBoundingClientRect(), vw = window.innerWidth, w = Math.min(352, vw - 16);
    setPos({ top: r.bottom + 6, left: Math.max(8, Math.min(r.left, vw - w - 8)), maxWidth: w });
  };
  useEffect(() => {
    if (!pos) return undefined;
    const hide = () => setPos(null);
    window.addEventListener("scroll", hide, true);
    return () => window.removeEventListener("scroll", hide, true);
  }, [pos]);
  const click = (e) => { e.stopPropagation(); e.preventDefault(); if (mouse.current || !pos) show(); else setPos(null); };
  return (
    <span ref={ref} className="inline-block" onPointerDown={(e) => { mouse.current = e.pointerType === "mouse"; }}
      onPointerEnter={(e) => e.pointerType === "mouse" && show()} onPointerLeave={(e) => e.pointerType === "mouse" && setPos(null)}
      onClick={click} data-testid={`term-${t}`}>
      <span className="underline decoration-dotted decoration-slate-400 underline-offset-4 cursor-help">{label || t}</span>
      {pos && <span role="tooltip" style={{ position: "fixed", ...pos }} className="z-[60] w-max rounded-md bg-slate-900 text-white text-[13px] leading-snug font-normal px-2.5 py-1.5 whitespace-normal text-left shadow-lg" data-testid={`term-tip-${t}`}>{tip || TERMS[t]}</span>}
    </span>
  );
}

const plain = (text) => String(text ?? "").replace(/(\d)\s*m2\b/g, "$1 m²").split(RE).map((s, i) => (i % 2 ? <Term key={i} t={s} /> : s));

// «N passos» diz quais ao tocar («4 passos: crédito aprovado, impostos pagos…»).
export function Glossed({ text, steps }) {
  if (!steps?.length) return plain(text);
  const parts = String(text ?? "").split(/(\d+ passos?(?::[^·]*)?)/);
  const tip = `${steps.length} ${steps.length === 1 ? "passo" : "passos"}: ${steps.map((s) => s.charAt(0).toLowerCase() + s.slice(1)).join(", ")}`;
  return parts.map((s, i) => (i % 2 ? <Term key={i} t="passos" label={s.trim()} tip={tip} /> : <span key={i}>{plain(s)}</span>));
}
